module.exports = __webpack_public_path__ + "img/symbol_8.4fe039a0.png";